import { useContext } from 'react'
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import { useFetching } from '../hooks/useFetching'
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context';
import AuthService from '../api/AuthService'

const AdminLogin = () => {

  const { control, handleSubmit } = useForm({
      mode: "onSubmit"
  })

  const redirect = useNavigate()

  const { setIsAuthAdmin, setAccessToken, setEmployeeId, setRoleName } = useContext(AuthContext)
  const [loginUser, isLoginLoading, loginErr] = useFetching(async (adminLogin, adminPassword) => {
    const response = await AuthService.login(adminLogin, adminPassword)
  
    setIsAuthAdmin(true)
    sessionStorage.setItem("isAuthAdmin", "true")

    setAccessToken(response.data.access_token)
    sessionStorage.setItem("access_token", response.data.access_token)

    setEmployeeId(response.data.employeeDto.employeeId)
    sessionStorage.setItem("employeeId", response.data.employeeDto.employeeId)

    setRoleName(response.data.employeeDto.role.name)
    sessionStorage.setItem("roleName", response.data.employeeDto.role.name)

    if (response.data.employeeDto.role.name == "admin") {
        redirect("/admin")
    } else {
        redirect("/")
    }

  })

  const login = (data) => {
    loginUser(data.login, data.password)
  }

  return (
    <section className="admin-login">
        <div className="admin-login__container container">
            <div className="admin-login__content">
                <h1 className="admin-login__title title">Вход</h1>
                <p className="admin-login__desc">
                    Используйте для входа данные о себе и номер зачетной книжки.
                </p>
                <form className='form' onSubmit={handleSubmit(login)}>
                    <label className='form__label'>
                        <span className='form__text'>Имя пользователя</span>
                        <Controller
                            control={control}
                            name='login'
                            rules={{
                                required: true
                            }}
                            render={({  field: { onChange }, fieldState: { error } }) => (
                                <div className={error ? 'error' : ''}>
                                    <Input type="text" className={`form__input ${error ? ' error' : ''}`} onChange={(newValue) => onChange(newValue)}/>
                                </div>
                            )}
                        />
                    </label>
                    <label className='form__label'>
                        <span className='form__text'>Пароль</span>
                        <Controller
                            control={control}
                            name='password'
                            rules={{
                                required: true
                            }}
                            render={({ field: { onChange }, fieldState: { error } }) => (
                                <div className={error ? 'error' : ''}>
                                    <Input type="password" className={`form__input ${error ? ' error' : ''}`} onChange={(newValue) => onChange(newValue)}/>
                                </div>
                            )}
                        />
                    </label>             
                    <Button className={`form__btn btn${isLoginLoading ? " disable" : ""}`} disabled={isLoginLoading}>
                        {isLoginLoading ? "Отправка..." : "Войти"}
                    </Button>
                </form>
            </div>
        </div>
    </section>
  )
}

export default AdminLogin